export default class StringSlice {
	constructor(s, i, j) {
		this.s = s;
		this.i = i;
		this.j = j;
	}
}
